import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProductHeader from '../ProductHeader/ProductHeader';
import ProductParameters from '../ProductParameters/ProductParameters';
import BottomWrapper from '../BottomWrapper/BottomWrapper';
import BottomWrapperWithView from '../BottomWrapper/BottomWrapperWithView';
import Ribbon from '../Ribbon/Ribbon';
import Reviews from '../Reviews/Reviews';
import ProductFeatures from '../Fetures/ProductFeatures';

const SingleContainerSelectedWrapper = styled.div`
  width: auto;
  border: solid 2px #666666;
  border-radius: 6px 6px 6px 6px;
  padding: 19px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    width: 205px;
    padding: 15px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 136px;
    padding: 5px;
  }
`;

const SingleContainerWrapper = styled.div`
  width: auto;
  border: solid 1px #e0e0e0;
  border-radius: 6px 6px 6px 6px;
  padding: 20px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    width: 206px;
    padding: 15px;
  }  
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 115px;
    padding: 15px;
  }
`;

const HeaderWrapper = styled.div`
  padding: 20px 0 0 0;
  display: flex;

  @media (max-width: 1239px) { 
    display: block;
  }
  
  @media (max-width: 1024px) { 
    display: flex;
  }  

  @media ${(props) => props.theme.breakpoints.tablet} {
    padding: 25px 0 0 0;
  }  

  @media ${(props) => props.theme.breakpoints.mobile} {
    display: block;
    padding: 25px 0 0 0;
  }
`;

const FooterWrapper = styled.div`
  padding: 15px 0 0 0;

  @media ${(props) => props.theme.breakpoints.tablet} {
    padding: 10px 0 0 0;
  } 

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 10px 0 0 0;
  }
`;

const SingleContainer = ({
  productTitle, productImgUrl, productUrl, isActualProduct, productParameters,
  featuresHeaderText, features,
  reviewsCount, rating, productId, productPrice, productCurrency, buttonText,
  buttonOnClick, viewButtonText, viewButtonOnClick, tradeUpPrice, psaVariant,
  productParametersLineLengths, productFeaturesMaxLineLength
}) => {

  let bottomWrapper = (
    <BottomWrapper
      productId={productId}
      productPrice={productPrice}
      productCurrency={productCurrency}
      buttonText={buttonText}
      buttonOnClick={buttonOnClick}
      psaVariant={psaVariant}
    />
  );
  if (!isActualProduct) {
    bottomWrapper = (
      <BottomWrapperWithView
        productId={productId}
        productPrice={productPrice}
        productCurrency={productCurrency}
        buttonText={buttonText}
        buttonOnClick={buttonOnClick}
        viewButtonText={viewButtonText}
        viewButtonOnClick={viewButtonOnClick}
        psaVariant={psaVariant}
      />
    );
  }

  let productFeatures = null;
  if (productFeaturesMaxLineLength.length !== 0) {
    productFeatures = (
      <ProductFeatures
        featuresHeaderText={featuresHeaderText}
        features={features}
        lineLengths={productFeaturesMaxLineLength}
      />
    );
  }

  const content = (
    <>
      <HeaderWrapper>
        <ProductHeader
          productTitle={productTitle}
          productImgUrl={productImgUrl}
          productUrl={productUrl}
          isActualProduct={isActualProduct}
          reviews={(
            <Reviews
              reviewsCount={reviewsCount}
              rating={rating}
            />
          )}
        />
      </HeaderWrapper>
      <ProductParameters
        parameters={productParameters}
        lineLengths={productParametersLineLengths}
      />
      {productFeatures}
      <FooterWrapper>
        {bottomWrapper}
      </FooterWrapper>
    </>
  );


  if (isActualProduct) {
    return (
      <div>
        <Ribbon price={tradeUpPrice} currency={productCurrency} isActualProduct />
        <SingleContainerSelectedWrapper>
          {content}
        </SingleContainerSelectedWrapper>
      </div>
    );
  }

  return (
    <div>
      <Ribbon price={tradeUpPrice} currency={productCurrency} />
      <SingleContainerWrapper>
        {content}
      </SingleContainerWrapper>
    </div>
  );

};

SingleContainer.propTypes = {
  featuresHeaderText: PropTypes.string.isRequired,
  productTitle: PropTypes.string.isRequired,
  productImgUrl: PropTypes.string.isRequired,
  productUrl: PropTypes.string.isRequired,
  isActualProduct: PropTypes.bool.isRequired,
  productParameters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      highlighted: PropTypes.bool.isRequired
    })
  ).isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired
    })
  ),
  reviewsCount: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  productId: PropTypes.string.isRequired,
  productPrice: PropTypes.number.isRequired,
  tradeUpPrice: PropTypes.number,
  productCurrency: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func,
  viewButtonText: PropTypes.string.isRequired,
  viewButtonOnClick: PropTypes.func,
  psaVariant: PropTypes.string.isRequired,
  productParametersLineLengths: PropTypes.arrayOf(PropTypes.number).isRequired,
  productFeaturesMaxLineLength: PropTypes.arrayOf(PropTypes.number).isRequired
};

SingleContainer.defaultProps = {
  tradeUpPrice: 0,
  productCurrency: 'GBP',
  buttonOnClick: () => {},
  features: null,
  viewButtonOnClick: () => {}
};

export default SingleContainer;
